// extracted by mini-css-extract-plugin
module.exports =  {"social-links":"b429494557--social-links--SiuFG","input-link":"b429494557--input-link--VLtQZ","vk":"b429494557--vk--YL3bQ","ok":"b429494557--ok--DH029"};